/**
 * Documentation Geoprod
 * Description des web services de Remoteprod
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *//* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
  HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';

import { ModelObject } from '../model/modelObject';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';
import {environment} from "../../../environments/environment";


@Injectable()
export class ApiEventsService {

  protected basePath = environment.api_url;
  public defaultHeaders = new HttpHeaders();
  public configuration = new Configuration();

  constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
    if (basePath) {
      this.basePath = basePath;
    }
    if (configuration) {
      this.configuration = configuration;
      this.basePath = basePath || configuration.basePath || this.basePath;
    }
  }

  /**
   * @param consumes string[] mime-types
   * @return true: consumes contains 'multipart/form-data', false: otherwise
   */
  private canConsumeForm(consumes: string[]): boolean {
    const form = 'multipart/form-data';
    for (const consume of consumes) {
      if (form === consume) {
        return true;
      }
    }
    return false;
  }


  /**
   * sert a modifier  le nom , la date de debut et fin de l’evenement suivant son id codé en md5 , ou ajouter un evenement ou suprimer un evenement d&#x27;un utilisateur
   *
   * @param cle &lt;/p&gt;Cle de l&#x27;operation &lt;br&gt; Si cle est create les parametre seulement titre , start et ens sont obligatoire&lt;br&gt; si le cle est update, seulement les parametre id , start ,end sont obligatoire (title est optionnel)&lt;br&gt; si le cle est remove, le paramtre seulement id est obligatoire &lt;p&gt;
   * @param id Identifiant de l&#x27;evenement utilisateur codé en md5 (obligatoire seulement pour la modification et la supression)
   * @param idUser Identifiant de utilisateur codé en md5 obligatoire seulement pour la creation
   * @param title Titre de l&#x27;evenement, Optionnel pour le modification (C&#x27;est a dire vous pouvez seulement modifier les date de l&#x27;evenenement)
   * @param start Date de debut de l&#x27;evenement sous le format suivant YYYY MM DD HH:MM:SS (Obligatoire pour la modification et la creation)
   * @param end Date de fin de l&#x27;evenement sous le format suivant YYYY MM DD HH:MM:SS (Obligatoire pour la modification et la creation)
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public createOrUpdateOrRemoveEventUserGet(cle: string, id?: ModelObject, idUser?: ModelObject, title?: ModelObject, start?: ModelObject, end?: ModelObject, observe?: 'body', reportProgress?: boolean): Observable<any>;
  public createOrUpdateOrRemoveEventUserGet(cle: string, id?: ModelObject, idUser?: ModelObject, title?: ModelObject, start?: ModelObject, end?: ModelObject, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
  public createOrUpdateOrRemoveEventUserGet(cle: string, id?: ModelObject, idUser?: ModelObject, title?: ModelObject, start?: ModelObject, end?: ModelObject, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
  public createOrUpdateOrRemoveEventUserGet(cle: string, id?: ModelObject, idUser?: ModelObject, title?: ModelObject, start?: ModelObject, end?: ModelObject, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

    if (cle === null || cle === undefined) {
      throw new Error('Required parameter cle was null or undefined when calling createOrUpdateOrRemoveEventUserGet.');
    }






    let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
    if (cle !== undefined && cle !== null) {
      queryParameters = queryParameters.set('cle', <any>cle);
    }
    if (id !== undefined && id !== null) {
      queryParameters = queryParameters.set('id', <any>id);
    }
    if (idUser !== undefined && idUser !== null) {
      queryParameters = queryParameters.set('id_user', <any>idUser);
    }
    if (title !== undefined && title !== null) {
      queryParameters = queryParameters.set('title', <any>title);
    }
    if (start !== undefined && start !== null) {
      queryParameters = queryParameters.set('start', <any>start);
    }
    if (end !== undefined && end !== null) {
      queryParameters = queryParameters.set('end', <any>end);
    }

    let headers = this.defaultHeaders;

    // authentication (Acess_Token) required
    if (this.configuration.apiKeys && this.configuration.apiKeys["idSession"]) {
      headers = headers.set('idSession', this.configuration.apiKeys["idSession"]);
    }

    // to determine the Accept header
    let httpHeaderAccepts: string[] = [
    ];
    const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    if (httpHeaderAcceptSelected != undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }

    // to determine the Content-Type header
    const consumes: string[] = [
    ];

    return this.httpClient.request<any>('get',`${this.basePath}/create_or_update_or_remove_event_user`,
      {
        params: queryParameters,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

}
